import { curry, prop } from 'ramda';

import { clear } from '../../../helpers/compact';
import { toDocType } from '../mapping';

const PRISMIC_LINK_TYPE = {
  WEB: 'Web',
  DOCUMENT: 'Document',
  MEDIA: 'Media',
};

// eslint-disable-next-line
export const toLink = (l: any): Link => {
  const { link_type: linkType, ...link } = l || {};
  if (PRISMIC_LINK_TYPE.WEB === linkType && link.url) {
    const { url, ...rest } = link;
    return clear({
      url,
      ...rest,
      linkType: 'link-web',
    });
  }

  if (PRISMIC_LINK_TYPE.MEDIA === linkType && link.url) {
    const { url, name, size, ...rest } = link;
    return clear({
      url,
      name,
      size,
      ...rest,
      linkType: 'link-media',
    });
  }

  if (PRISMIC_LINK_TYPE.DOCUMENT === linkType) {
    return clear({
      linkType: 'link-document',
      type: toDocType(link.type),
      id: link.id,
      lang: link.lang,
      uid: link.uid,
    });
  }

  return undefined;
};

type BaseLink = {
  linkType: string;
};

export type LinkDocument = BaseLink & {
  type: string;
  id: string;
  lang: string;
  uid?: string;
};

export type LinkWeb = BaseLink & {
  url: string;
};

export type LinkMedia = BaseLink & {
  name: string;
  url: string;
  size: string;
  kind?: string;
};

export type Link = LinkDocument | LinkWeb | LinkMedia | undefined;

export const toLinkFromProp = curry((p, val) => toLink(prop(p, val)));
